import { calculateLuminance } from "./calculate-luminance";
import type { HexColor } from "./hex-color/hex-color";
import type { HSL } from "./hsla-color/hsl-color";
import type { HSLA } from "./hsla-color/hsla-color";
import type { RGB } from "./rgba-color/rgb-color";
import type { RGBA } from "./rgba-color/rgba-color";

/**
 * Determines if a hex color is light or dark.
 * @param hex - The hex color string.
 * @returns 'light' if the color is light, 'dark' if the color is dark.
 */
const isLightOrDarkColor = (
    color: RGB | RGBA | HSL | HSLA | HexColor,
): "light" | "dark" => {
    const luminance = calculateLuminance(color);
    return luminance < 0.5 ? "dark" : "light";
};

export { isLightOrDarkColor };
